class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden-mob');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden-mob');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      
      // Trigger cart update event for enhancements
      this.dispatchEvent(new CustomEvent('cart:open'));
      
      // Fetch latest cart and trigger update
      fetch(`${routes.cart_url}.js`)
        .then(response => response.json())
        .then(cart => {
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        })
        .catch(error => console.error('Error fetching cart:', error));
    });

    if (window.MAKEBECOOL_BUNDLES && typeof window.MAKEBECOOL_BUNDLES.updateCart === 'function') {
      window.MAKEBECOOL_BUNDLES.updateCart()
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  // Override updateQuantity to trigger cart update event
  updateQuantity(line, quantity, name) {
    return super.updateQuantity(line, quantity, name).then((parsedState) => {
      // Fetch updated cart and trigger event
      return fetch(`${routes.cart_url}.js`)
        .then(response => response.json())
        .then(cart => {
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          return parsedState;
        })
        .catch(error => {
          console.error('Error fetching cart after update:', error);
          // Still return the parsed state even if cart fetch fails
          return parsedState;
        });
    }).catch((error) => {
      // Re-throw error from parent
      throw error;
    });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('MAKEBECOOL_BUNDLES.updateCart', (event) => {
  const $cartDrawer = document.querySelector('cart-drawer')
  const $cartDrawerItems = $cartDrawer.querySelector('cart-drawer-items')

  fetch(`${routes.cart_url}`, { ...fetchConfig() })
    .then((response) => {
      return response.text()
    })
    .then((state) => {
      const parsedState = JSON.parse(state)
      $cartDrawerItems.updateQuantity(1, parsedState.items[0].quantity)
    })
    .finally(() => {
      $cartDrawer.open()
    })
})
